import ReportList from './ReportList';
import ReportShow from './ReportShow';

export default {
  list: ReportList,
  show: ReportShow,
};
